export const calculatePercent = (value, total) => (value / total) * 100.0

export const percentToDecimal = (percentage) => percentage / 100.0
